























































































































import Vue from 'vue'
import api from '../../../../api'

export default Vue.extend({
  data() {
    return {
      loading: false,
      dispatchings: [] as any[],
      stats: {
        totalAmount: 0,
        totalAmountSuccess: 0,
        totalAmountPending: 0,
        totalAmountFailed: 0
      },
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0,
      sfdName: '' as string,
      columns: [
        { label: 'Nom', field: 'name' },
        { label: 'Date de création', field: 'createdAt' },
        { label: 'Montant total', field: 'totalAmount' },
        { label: 'Crédits total', field: 'creditsCount' },
        { label: 'Succès', field: 'creditsSuccessCount' },
        { label: 'En attente', field: 'creditsPendingCount' },
        { label: 'Échec', field: 'creditsFailedCount' },
        { label: 'État', field: 'state' },
        { label: 'Actions', field: '_actions' }
      ]
    }
  },

  computed: {
    sfdId(): string {
      return this.$route.params.sfdId
    },

    creditLineId(): string {
      return this.$route.params.creditLineId
    }
  },

  methods: {
    formatAmount(amount: number): string {
      return new Intl.NumberFormat('fr-FR').format(amount || 0)
    },

    formatDate(date: string): string {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },

    getCacheKey(key: string): string {
      return `dispatching_${this.creditLineId}_${key}`
    },

    loadFromCache(key: string): any {
      try {
        const cached = localStorage.getItem(this.getCacheKey(key))
        if (cached) {
          const data = JSON.parse(cached)
          const expiryTime = 5 * 60 * 1000
          if (Date.now() - data.timestamp < expiryTime) {
            return data.value
          }
        }
      } catch (error) {
        console.error('Error loading from cache:', error)
      }
      return null
    },

    saveToCache(key: string, value: any): void {
      try {
        localStorage.setItem(
          this.getCacheKey(key),
          JSON.stringify({
            value,
            timestamp: Date.now()
          })
        )
      } catch (error) {
        console.error('Error saving to cache:', error)
      }
    },

    async loadSfdName() {
      try {
        const cachedName = localStorage.getItem(`sfd_${this.sfdId}_name`)
        if (cachedName) {
          this.sfdName = cachedName
        }
      } catch (error) {
        console.error('Error loading SFD name:', error)
      }
    },

    async loadDispatchings() {
      const cacheKey = `dispatchings_page${this.page}`
      const cachedData = this.loadFromCache(cacheKey)
      if (cachedData) {
        this.dispatchings = cachedData.data.map((d: any) => ({
          ...d,
          createdAt: this.formatDate(d.createdAt)
        }))
        this.stats = cachedData.stats
        this.total = cachedData.total
        this.totalPages = cachedData.totalPages
      }

      this.loading = true
      try {
        const response = await api.get(
          `/dispatchings/credit-line/${this.creditLineId}/with-stats`,
          {
            params: {
              page: this.page,
              limit: this.limit
            }
          }
        )
        this.dispatchings = response.data.data.map((d: any) => ({
          ...d,
          createdAt: this.formatDate(d.createdAt)
        }))
        this.stats = response.data.stats
        this.total = response.data.total
        this.totalPages = response.data.totalPages
        this.saveToCache(cacheKey, response.data)
      } catch (error) {
        console.error('Error loading dispatchings:', error)
        this.$notify.error('Erreur lors du chargement des dispatchings')
      } finally {
        this.loading = false
      }
    },

    async changePage(newPage: number) {
      if (newPage < 1 || newPage > this.totalPages) return
      this.page = newPage
      await this.loadDispatchings()
    },

    viewCredits(dispatchingId: string) {
      this.$router.push({
        name: 'sfds.dispatching.credits',
        params: {
          sfdId: this.sfdId,
          dispatchingId
        }
      })
    }
  },

  async created() {
    await this.loadSfdName()
    await this.loadDispatchings()
  }
})
